import { render, staticRenderFns } from "./join-done.vue?vue&type=template&id=2957a30a&scoped=true&lang=pug&"
import script from "./join-done.vue?vue&type=script&lang=js&"
export * from "./join-done.vue?vue&type=script&lang=js&"
import style0 from "../access.scss?vue&type=style&index=0&id=2957a30a&lang=scss&scoped=true&"
import style1 from "./join-done.vue?vue&type=style&index=1&id=2957a30a&lang=scss&scoped=true&"
import style2 from "./join-done.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957a30a",
  null
  
)

export default component.exports